export default __webpack_public_path__ + "static/media/BI.07f95994.ico";